import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

import { SelfCareActivity } from '../../../../../types/entity.types';

import { ARCHIVED, UPCOMING } from '../../../../../utils/constants';
import { getClassNames } from '../../../../../utils/util';

import Button from '../../../../common/button/Button';

import { ReactComponent as DeleteIcon } from '../../../../../resources/icons/close.svg';

import '../accountability.scss';
import './accountability-self-care.scss';

type Props = {
  status: string;
  selfCareActivities: SelfCareActivity[];
  createSelfCareActivity: () => void;
  updateSelfCareActivity: (externalReference: string, value: string) => void;
  deleteSelfCareActivity: (externalReference: string) => void;
};

const AccountabilitySelfCare = ({
  status,
  selfCareActivities,
  createSelfCareActivity,
  updateSelfCareActivity,
  deleteSelfCareActivity
}: Props) => {
  const [open, setOpen] = useState(true);

  return (
    <div
      className={getClassNames('accountability__section', {
        closed: !open
      })}
      data-testid="accountability-self-care"
    >
      <div className="accountability__section__header">
        <p>SELF-CARE</p>
        {!open && (
          <FontAwesomeIcon
            className="accountability__section__open-icon"
            icon={faPlus}
            onClick={() => setOpen(true)}
            data-testid="open-icon"
          />
        )}
        {open && (
          <FontAwesomeIcon
            className="accountability__section__close-icon"
            icon={faMinus}
            onClick={() => setOpen(false)}
            data-testid="close-icon"
          />
        )}
      </div>
      {open && (
        <div className="accountability-self-care">
          {selfCareActivities.length > 0 && <p>Optional Self-Care Activities</p>}
          {selfCareActivities.map((activity, index) => (
            <div key={index} data-testid="self-care-activity">
              <input
                className="accountability-self-care__input"
                value={activity.name}
                onChange={({ target }) => updateSelfCareActivity(activity.externalReference, target.value)}
                disabled={status === ARCHIVED}
              />
              {status === UPCOMING && selfCareActivities.length > 1 && (
                <DeleteIcon
                  className="accountability-self-care__delete-icon"
                  onClick={() => deleteSelfCareActivity(activity.externalReference)}
                  data-testid="delete-icon"
                />
              )}
            </div>
          ))}
          {status !== ARCHIVED && <Button text="Add" onClick={createSelfCareActivity} />}
        </div>
      )}
    </div>
  );
};

export default AccountabilitySelfCare;
